var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    _vm.componentStyle.comp,
    _vm._b(
      {
        tag: "component",
        on: {
          "click:outside": function ($event) {
            _vm.$vuetify.breakpoint.mdAndUp ? _vm.close() : null
          },
        },
        model: {
          value: _vm.show,
          callback: function ($$v) {
            _vm.show = $$v
          },
          expression: "show",
        },
      },
      "component",
      { ..._vm.componentStyle.props },
      false
    ),
    [
      _c(
        "v-form",
        {
          ref: "form",
          staticClass: "contents",
          on: {
            submit: function ($event) {
              $event.preventDefault()
              return _vm.validate()
            },
          },
          model: {
            value: _vm.valid,
            callback: function ($$v) {
              _vm.valid = $$v
            },
            expression: "valid",
          },
        },
        [
          _c("ConversationToolbar", {
            attrs: {
              conversation: _vm.conversation,
              thread: _vm.thread,
              crmMode: _vm.crmMode,
              rules: _vm.rules.recipients,
              disabled: _vm.form.processing || _vm.messageSending,
              error: _vm.errors.recipients,
              crmClient: _vm.crmClient,
              searching: _vm.searching,
            },
            on: {
              changeThread: function ($event) {
                return _vm.$emit("changeThread", $event)
              },
              openCrm: function ($event) {
                return _vm.$emit("openCrm")
              },
              close: function ($event) {
                return _vm.close()
              },
              input: function ($event) {
                return _vm.createConversation($event)
              },
            },
            model: {
              value: _vm.form.recipients,
              callback: function ($$v) {
                _vm.$set(_vm.form, "recipients", $$v)
              },
              expression: "form.recipients",
            },
          }),
          _vm._v(" "),
          _c("v-divider"),
          _vm._v(" "),
          _vm.loading || _vm.crmLoading
            ? _c(
                "div",
                {
                  staticClass: "w-full h-full flex justify-center align-center",
                },
                [
                  _c("v-progress-circular", {
                    attrs: { indeterminate: "", color: "primary" },
                  }),
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _c(
            "ConversationMessages",
            {
              key: _vm.messagesKey,
              ref: "messages",
              attrs: {
                cursor: _vm.cursor,
                conversation: _vm.conversation,
                conversationUser: _vm.conversationUser,
                thread: _vm.thread,
                messages: _vm.messages,
                messageCount: _vm.messageCount,
                participants: _vm.conversation?.participants,
                crmMode: _vm.crmMode,
                searching: _vm.searching,
              },
              on: {
                changeThread: function ($event) {
                  return _vm.$emit("changeThread", $event)
                },
                handleUnread: function ($event) {
                  return _vm.$emit("handleUnread", $event)
                },
                loading: function ($event) {
                  ;[(_vm.loading = $event), _vm.$emit("loading", $event)]
                },
              },
            },
            [
              _vm.newMessageAvailable
                ? _c(
                    "div",
                    {
                      staticClass: "w-min mx-auto flex justify-center",
                      staticStyle: {
                        position: "sticky",
                        top: "94%",
                        "z-index": "60",
                      },
                    },
                    [
                      _c(
                        "v-chip",
                        {
                          attrs: { pill: "", color: "primary" },
                          on: {
                            click: function ($event) {
                              return _vm.viewLatest(_vm.newMessageAvailable)
                            },
                          },
                        },
                        [
                          _c(
                            "v-icon",
                            { staticClass: "mr-1", attrs: { small: "" } },
                            [_vm._v("arrow_downward")]
                          ),
                          _c("b", [_vm._v("New Message")]),
                        ],
                        1
                      ),
                    ],
                    1
                  )
                : _vm._e(),
            ]
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "px-4 mt-4 safe-bottom", attrs: { id: "chat-box" } },
            [
              _vm.channel == "email"
                ? _c("v-text-field", {
                    staticClass: "mb-2",
                    attrs: {
                      dense: "",
                      outlined: "",
                      "error-messages": _vm.errors.subject,
                      rules: _vm.rules.subject,
                      disabled: !!_vm.form.thread_id,
                      label: "Subject",
                      "hide-details": "auto",
                    },
                    model: {
                      value: _vm.form.subject,
                      callback: function ($$v) {
                        _vm.$set(_vm.form, "subject", $$v)
                      },
                      expression: "form.subject",
                    },
                  })
                : _vm._e(),
              _vm._v(" "),
              _c("TipTap", {
                key: _vm.tipTapKey,
                ref: "content",
                attrs: {
                  processing: _vm.form.processing || _vm.messageSending,
                  valid:
                    _vm.valid && _vm.hasContent && !_vm.hasDeletedParticipants,
                  characterLimit: _vm.characterLimit,
                  channel: _vm.channel,
                  editorType: ["chat", "email"].includes(_vm.channel)
                    ? "html"
                    : "text",
                  autofocus: !_vm.conversation.create,
                  crmMode: _vm.crmMode,
                  conversationId: _vm.conversation.id,
                  client: _vm.form.recipients[0],
                  thread: _vm.thread,
                  message: _vm.assistantMessage,
                  autoDraft: !!_vm.conversationUser?.auto_drafted_at,
                },
                on: {
                  showMessage: function ($event) {
                    return _vm.$emit("showMessage")
                  },
                  error: function ($event) {
                    return _vm.assistantError($event)
                  },
                  contentTrimmed: function ($event) {
                    return _vm.contentTrimmedAlert()
                  },
                  changeChannel: function ($event) {
                    return _vm.changeChannel($event)
                  },
                  input: function ($event) {
                    return _vm.saveDraft($event)
                  },
                  submit: function ($event) {
                    return _vm.validate()
                  },
                },
                model: {
                  value: _vm.form.content,
                  callback: function ($$v) {
                    _vm.$set(_vm.form, "content", $$v)
                  },
                  expression: "form.content",
                },
              }),
              _vm._v(" "),
              _c("v-input", {
                ref: "contentInput",
                staticClass: "px-6",
                attrs: {
                  rules: _vm.rules.content,
                  value: _vm.form.content,
                  "error-messages": _vm.draftErrors,
                  "hide-details": "auto",
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }